var PhotoUploaderControl = (function ($) {

    PhotoUploaderControl = function (options) {
        var that = this;

        options = options || {};

        // DOM
        that.$wrapper = options['$wrapper'] || '';

        // CONST
        that.modals = options['modals'] || {};
        that.locales = options['locales'] || {};
        that.icons = options['icons'] || {};
        that.photo = options['photo'] || {};
        that.photo_max_filesize = options['photo_max_filesize'];
        that.image_allowed_extensions = options['image_allowed_extensions'];
        that.is_modal = options['is_modal'] || false;
        that.reload_on_change = options['reload_on_change'] === undefined ? true : options['reload_on_change']; // Нужно ли вызывать обновление контента при изменении фото. Запрет перезагрузки полезен при вызове контрола из drawer
        that.notifier_time = 4000;
        that.class = {
            button_delete: '.js-button-delete',
            button_confirm: '.js-button-confirm',
            edit_photo: '.js-edit-photo',
            my_photo: '.js-my-photo'
        };

        // DYNAMIC VARS
        that.is_locked = false;
        that.ui_edit_photo_modal = null;
        that.photo_uploader = null;

        // CALLBACKS
        that.onChange = options['onChange'] || null; // Вызывается при изменении или удалении фото

        // INIT
        that.init();
    };

    PhotoUploaderControl.prototype.init = function () {
        var that = this;

        if ('' === that.$wrapper) {
            return;
        }

        that.$wrapper.on('click', that.class.edit_photo, function () {
            that.__showEditModal();
        });
    };

    /**
     * @private
     */
    PhotoUploaderControl.prototype.__showEditModal = function () {
        var that = this;

        that.ui_edit_photo_modal = $.uiModal({
            html: that.modals['edit_photo_form'],
            onOpen: function ($modal_wrapper) {
                that.photo_uploader = $.uiPhotoUploader({
                    wrapper: $modal_wrapper,
                    photo: that.photo,
                    photo_max_filesize: that.photo_max_filesize,
                    image_allowed_extensions: that.image_allowed_extensions,
                    onCropperReady: function (uploader) {
                        $modal_wrapper.find(that.class.button_confirm).attr('disabled', false);
                    },
                    onError: function (uploader, file, error) {
                        var uploader_modal_error_title = that.locales.uploader_modal_error_title;
                        if ('wrong_extension' === error) {
                            that.__showUploaderError(uploader_modal_error_title, that.locales.uploader_wrong_extension_modal_error_text);
                        } else if ('size_exceeded' === error) {
                            that.__showUploaderError(uploader_modal_error_title, that.locales.uploader_size_exceeded_modal_error_text);
                        } else {
                            that.__showUploaderError(uploader_modal_error_title, that.locales.uploader_modal_error_text);
                        }

                        return false;
                    }
                });
                $modal_wrapper.find(that.class.button_delete).toggleClass('hidden', !that.photo.full_size);
                $modal_wrapper.on('click', that.class.button_delete, function () {
                    that.__delete(that.photo_uploader);
                    that.ui_edit_photo_modal.close();
                });
            },
            onButtonConfirmClick: function () {
                that.__save();
            }
        });
    };

    /**
     * @private
     */
    PhotoUploaderControl.prototype.__save = function () {
        var that = this,
            url = $.sa.build_url('my/photo-save/'),
            form_data = that.photo_uploader.getFormData(),
            $button_confirm = that.ui_edit_photo_modal.$modal_body.find(that.class.button_confirm);

        if (that.is_locked) {
            return false;
        }
        that.is_locked = true;
        $.sa.buttonLoading($button_confirm, true);

        $.ajax(url, {
            method: 'post',
            data: form_data,
            processData: false,
            contentType: false
        }).done(function (response) {
            if (response.status === 'ok') {
                that.__handleSaveSuccess(response);
            } else if (response.status === 'fail') {
                that.__handleSaveError();
            }
        }).fail(function () {
            that.__handleSaveError();
        }).always(function () {
            $.sa.buttonLoading($button_confirm, false);
            that.is_locked = false;
        });
    };

    /**
     * @param response
     * @private
     */
    PhotoUploaderControl.prototype.__handleSaveSuccess = function (response) {
        var that = this;

        that.photo = response.data.photo;

        $(that.class.my_photo).css('background-image', 'url(' + that.photo.small_size + ')');

        if(that.onChange) {
            that.onChange(that);
        }

        if (that.reload_on_change) {
            $.sa.content_router.reload();
        }
    };

    /**
     * @private
     */
    PhotoUploaderControl.prototype.__handleSaveError = function () {
        var that = this;

        that.__showNotify(that.locales['save_photo_error_notify_title'], $.sa.notifier.class.error);
    };

    /**
     * @private
     */
    PhotoUploaderControl.prototype.__delete = function () {
        var that = this,
            url = $.sa.build_url('my/photo-delete/');

        $.post(url, {})
         .done(function (response) {
             if (response.status === 'ok') {
                 that.__handleDeleteSuccess();
             } else if (response.status === 'fail') {
                 that.__handleDeleteError();
             }
         }).fail(function () {
            that.__handleDeleteError();
        });
    };

    /**
     * @private
     */
    PhotoUploaderControl.prototype.__handleDeleteSuccess = function () {
        var that = this;

        that.photo = {
            small_size: that.icons.photo_user_icon,
            full_size: ''
        };

        $(that.class.my_photo).css('background-image', 'url(' + that.icons.photo_user_icon + ')');
        $('.card-avatar-list ' + that.class.my_photo).css('background-image', 'url(' + that.icons.photo_user_gray_icon + ')');

        if(that.onChange) {
            that.onChange(that);
        }

        if (that.reload_on_change) {
            $.sa.content_router.reload();
        }
    };


    /**
     * @private
     */
    PhotoUploaderControl.prototype.__handleDeleteError = function () {
        var that = this;

        that.__showNotify(that.locales['delete_photo_error_notify_title'], $.sa.notifier.class.error);
    };

    /**
     * @param title
     * @param notifier_class
     * @private
     */
    PhotoUploaderControl.prototype.__showNotify = function (title, notifier_class) {
        var that = this;

        $.sa.notifier.show({
            title: title,
            notifier_class: notifier_class,
            time: that.notifier_time,
        });
    };

    /**
     * @param title
     * @param content
     * @private
     */
    PhotoUploaderControl.prototype.__showUploaderError = function (title, content) {
        $.uiModal({
            header_title: title,
            content: content,
        });
    };

    return PhotoUploaderControl;
})(jQuery);
